import { useEffect, useRef } from 'react';

// A row whose status the user just changed moves to another status card, often outside the
// viewport. Scroll it into view so its arrival tint (statusChanged in task.styles.js) is seen;
// the scroll jumps instead of gliding under prefers-reduced-motion. Returns the ref for the row.
const useRevealOnStatusChange = (statusChanged) => {
  const rowRef = useRef(null);
  useEffect(() => {
    if (!statusChanged) {
      return;
    }
    const reduceMotion = window.matchMedia?.('(prefers-reduced-motion: reduce)').matches;
    rowRef.current?.scrollIntoView({ block: 'nearest', behavior: reduceMotion ? 'auto' : 'smooth' });
  }, [statusChanged]);
  return rowRef;
};

export default useRevealOnStatusChange;
